import { Divider, Typography } from "@mui/material";

function Footer() {
    return <div className="footer">
        <Divider/>
        <Typography variant="body2">Footer</Typography>
    </div>;

}
export default Footer;
